import angular from 'angular';
import signupConfig from './signup.config';

import signup from '../../containers/signup';

const signupModule = angular.module('meredicte.signup', [])
  .component('appSignup', signup)
  .config(signupConfig);

export default signupModule;



// WEBPACK FOOTER //
// ./src/modules/signup/signup.module.js